// src/firebase.js
// ─────────────────────────────────────────────────────────────
// STEP 1: Replace the values below with your Firebase project config.
// Get them from: Firebase Console → Project Settings → Your apps → SDK setup
// ─────────────────────────────────────────────────────────────
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDj4xBbwAudqsU4fXRx7Nm41lk0msjhoKs",
  authDomain: "hatharasingheenterprises.firebaseapp.com",
  projectId: "hatharasingheenterprises",
  storageBucket: "hatharasingheenterprises.firebasestorage.app",
  messagingSenderId: "498100967460",
  appId: "1:498100967460:web:9e377986abb7665c5de0b1",
  measurementId: "G-GLNQ0ELH21"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

// Analytics only works in the browser (not SSR) and requires cookies/IndexedDB support.
export let analytics = null;
isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
});
